import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { findRenderedDOMComponentWithTag } from "react-dom/cjs/react-dom-test-utils.development";
import { LANGUAGES } from "../common/constant";
//css
import "./Language.css";
import "../common/Common.css";
import Loader from "../common/Loader";

function Language(props) {
  const [language, setLanguage] = useState("");
  const [loading, setLoading] = useState(false);
  return (
    <div className="window-outer">
      <Row className="window-center">
        <Row className="row-center">
          <Form.Group
            as={Row}
            controlId="formGridState"
            style={{ justifyContent: "center" }}
          >
            <Form.Label style={{ textAlign: "center" }}>
              Choose your language? / ¿Elige tu idioma?
            </Form.Label>
            <Form.Select
              value={language}
              style={{ width: "max-content" }}
              onChange={(e) => {
                setLanguage(e.target.value);
              }}
            >
              <option value="">Select</option>
              {LANGUAGES.map((obj) => {
                return (
                  <option key={obj.code} value={obj.code}>
                    {obj.language}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        </Row>
        <Row className="row-center">
          <Button
            style={{ width: "100px", margin: "auto" }}
            className="login-btn"
            disabled={!language && !loading ? true : false}
            onClick={(e) => {
              e.preventDefault();
              setLoading(true);
              props.onSave(language);
              setLoading(false);
            }}
          >
            {loading ? (
              <Loader
                loading={loading}
                loader={"loader  loader-login"}
                loaderColor={"#ffffff"}
                size={4}
              />
            ) : (
              <label className="login-btn-label">OK</label>
            )}
          </Button>
        </Row>
      </Row>
    </div>
  );
}

export default Language;
